<template>
  <div class="change-room">
    <div class="bottom-part">
      <div class="title">更换寝室</div>
      <div class="basic">
        <div>{{ userInfo.Name }} {{ userInfo.Mobile }}</div>
        <div style="font-size:14px;">{{ userInfo.RegionName }}</div>
        <div style="font-size:14px;">{{ userInfo.FullAddress }}</div>
        <!--    当前有效订单    -->
        <van-row class="valid-orders-old order-box">
          <template v-if="userValidOrderLoading">
            <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;">
              <van-loading style="margin-bottom: 15px" size="24px"></van-loading>
              <div>加载中...</div>
            </div>
          </template>
          <template v-else>
            <template v-if="userValidOrderInfo && hasValidOrder">
              <van-col span="24">{{ userValidOrderInfo.BizOrderPackageInfo.Name }}</van-col>
              <van-col span="12">押&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;金：￥{{ userValidOrderInfo.BizOrderPackageInfo.Deposit }}</van-col>
              <van-col span="12">租&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;金：￥{{ userValidOrderInfo.BizOrderPackageInfo.Price }}</van-col>
              <van-col span="12">合同押金：￥{{ userValidOrderInfo.BizParentOrder.Deposit }}</van-col>
              <van-col span="12">合同租金：￥{{ userValidOrderInfo.BizParentOrder.Price }}</van-col>
              <van-col span="24">有效时长：{{ userValidOrderInfo.BizOrderPackageInfo.EndTimeStr }}</van-col>
            </template>
            <template v-else>
              <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center">寝室下暂无我的合同</div>
            </template>
          </template>
        </van-row>
      </div>
      <van-divider/>
      <div style="text-align: center">⬇</div>
      <van-cell class="new-addr" is-link @click="addrVisible = true">
        <van-icon name="location"/>
        <div v-if="newAddress" class="n_addr">
          <div>新地址：</div>
          <div>
            <div>{{addr.RegionName}}</div>
            <div>{{addr.FullAddress}}</div>
          </div>
        </div>
        <span v-else>请选择更换寝室地址</span>
      </van-cell>
<!--      <van-divider/>-->

      <!-- 目标寝室合同 -->

      <van-row class="valid-orders-new order-box">
        <template v-if="targetAddrValidOrderLoading">
          <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;color: #9F9F9F">
            <van-loading style="margin-bottom: 15px" size="24px"></van-loading>
            <div>加载中...</div>
          </div>
        </template>
        <template v-else>
          <template v-if="targetAddrValidOrderInfo && showNewOrder">
            <van-col span="24">{{ targetAddrValidOrderInfo.BizOrderPackageInfo.Name }}</van-col>
            <van-col span="12">押&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;金：￥{{ targetAddrValidOrderInfo.BizOrderPackageInfo.Deposit }}</van-col>
            <van-col span="12">租&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;金：￥{{ targetAddrValidOrderInfo.BizOrderPackageInfo.Price }}</van-col>
            <van-col span="12">合同押金：￥{{ targetAddrValidOrderInfo.BizParentOrder.Deposit }}</van-col>
            <van-col span="12">合同租金：￥{{ targetAddrValidOrderInfo.BizParentOrder.Price }}</van-col>
            <van-col span="24">有效时长：{{ targetAddrValidOrderInfo.BizOrderPackageInfo.EndTimeStr }}</van-col>
          </template>
          <template v-else>
            <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;color: #9F9F9F">寝室下暂无有效合同</div>
          </template>
        </template>
      </van-row>

      <template v-if="newAddress">


        <template v-if="hasValidOrder">
          <!--操作处理new-->
          <template>
            <div class="group-item">
              <div>操作处理</div>
              <van-radio-group v-model="newSingleOperation"
                               @change="changeSingleOperation">
                <van-radio shape="square"
                           checked-color="#4BC163"
                           :disabled="isWarning"
                           label-position="left" name="IsCreate">
                  <div>带走合同/原合同取消</div>
                  <div style="font-size: 12px;color: #FF976A">*换寝创建新合同套餐内容不变。</div>
                </van-radio>
                <van-radio shape="square"
                           checked-color="#4BC163"
                           :disabled="isOnly"
                           label-position="left" name="IsCancel">保留合同/更换代表</van-radio>
                <van-radio shape="square"
                           checked-color="#4BC163"
                           label-position="left" name="IsReturn">合同不保留/退租原合同</van-radio>
                <van-radio shape="square"
                           checked-color="#4BC163"
                           disabled
                           label-position="left" name="直接换寝">直接换寝</van-radio>
              </van-radio-group>
            </div>
            <van-divider/>
          </template>
          <!--  新代表  -->
          <template v-if="(IsProxy && !isOnly) && newSingleOperation === 'IsCancel'">
            <div class="group-item">
              <div>新代表</div>
              <van-radio-group v-model="newSingleMember">
                <van-radio v-for="item in allMemberList"
                              :key="item.Id"
                              shape="square"
                              checked-color="#4BC163"
                              label-position="left"
                              :disabled="item.Id === userValidOrderInfo.BizMemberInfo.Id"
                              :name="item.Id">{{ item.Name }}
                </van-radio>
              </van-radio-group>
            </div>
            <van-divider/>
          </template>

          <!--  操作处理  -->
<!--          <template>-->
<!--            <div class="group-item">-->
<!--              <div>操作处理</div>-->
<!--              <van-checkbox-group v-model="newOperations" @change="linkage">-->
<!--                <van-checkbox shape="square"-->
<!--                              checked-color="#4BC163"-->
<!--                              label-position="left" :disabled="isDisabledIsCreate" name="IsCreate">创建新合同</van-checkbox>-->
<!--                <van-checkbox shape="square"-->
<!--                              checked-color="#4BC163"-->
<!--                              label-position="left" :disabled="isDisabledCancel" name="IsCancel">取消旧合同</van-checkbox>-->
<!--                <van-checkbox shape="square"-->
<!--                              checked-color="#4BC163"-->
<!--                              label-position="left" :disabled="isDisabledReturn" name="IsReturn">退租旧合同</van-checkbox>-->
<!--                <van-checkbox shape="square"-->
<!--                              checked-color="#4BC163"-->
<!--                              disabled-->
<!--                              label-position="left" name="直接换寝">直接换寝</van-checkbox>-->
<!--              </van-checkbox-group>-->
<!--            </div>-->
<!--            <van-divider/>-->
<!--          </template>-->


          <!--  退租 -->
          <template v-if="newSingleOperation === 'IsReturn'">
            <div class="group-item refund">
              <div>合同信息</div>
              <van-cell title="合同押金" :value="'￥' + userValidOrderInfo.BizParentOrder.Deposit"></van-cell>
              <van-cell title="合同租金" :value="'￥' + userValidOrderInfo.BizParentOrder.Price"></van-cell>
              <van-divider/>
              <van-field
                  v-model="newRefundInfo.Deposit"
                  label="退款押金"
                  type="number"
                  label-width="120"
                  input-align="right"
                  error-message-align="right"
                  @input="replacePrice('Deposit')"
                  placeholder="请输入退款押金"
                  @blur="checkMoney('Deposit')"
                  :error-message="errorMsg.Deposit"
              >
                <template #label><span style="color: transparent">*</span>退款押金</template>
              </van-field>
<!--              <van-divider/>-->
              <van-field
                  v-model="newRefundInfo.Price"
                  label="退款租金"
                  type="number"
                  label-width="120"
                  input-align="right"
                  error-message-align="right"
                  @input="replacePrice('Price')"
                  placeholder="请输入退款租金"
                  @blur="checkMoney('Price')"
                  :error-message="errorMsg.Price"
              >
                <template #label><span style="color: transparent">*</span>退款租金</template>
              </van-field>
<!--              <van-divider/>-->
              <van-cell
                  title="开户银行"
                  is-link
                  :value="newRefundInfo.Bank"
                  @click="showBankList = true"
              >
                <template #title>
                  <span style="color: #646566;padding-left: 7px">开户银行</span>
                </template>
              </van-cell>
              <van-field
                  v-model="newRefundInfo.BankNumber"
                  label="银行卡号"
                  type="number"
                  label-width="120"
                  input-align="right"
                  error-message-align="right"
                  placeholder="请输入银行卡号"
                  @input="replaceNumber('BankNumber')"
                  :error-message="errorMsg.BankNumber"
              >
                <template #label><span style="color: red">*</span>银行卡号</template>
              </van-field>
<!--              <van-divider/>-->
              <van-field
                  v-model="newRefundInfo.RentReason"
                  label="退租原因"
                  type="textarea"
                  label-width="120"
                  input-align="right"
                  error-message-align="right"
                  placeholder="请输入退租原因"
                  :error-message="errorMsg.RentReason"
              >
                <template #label><span style="color: red">*</span>退租原因</template>
              </van-field>
              <van-divider/>
            </div>
          </template>
        </template>
        <template v-else>
          <template>
            <div class="group-item">
              <div>操作处理</div>
              <van-checkbox-group v-model="newOperations" @change="linkage">
                <van-checkbox shape="square"
                              checked-color="#4BC163"
                              disabled
                              label-position="left" name="直接换寝">直接换寝</van-checkbox>
              </van-checkbox-group>
            </div>
          </template>
        </template>
      </template>

    </div>
    <div class="top-btn">
      <div class="cancel" @click="cancel">取消</div>
      <div class="submit" @click="submit">确定</div>
    </div>
    <van-popup v-model="addrVisible" style="width: 100%;height: 100%" position="right">
      <change-addr v-if="addrVisible" @close="addrVisible = false" is-cache @changeAddr="getNewAddr" is-popup></change-addr>
    </van-popup>
    <van-popup v-model="showBankList" get-container="body" position="bottom">
      <van-picker
          :columns="bankList"
          show-toolbar
          title="开户银行"
          @cancel="showBankList = !showBankList"
          @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>

import { getWeixInfo } from "@/utils/auth";
import changeAddr from "@/views/user/changeAddr/index.vue";

export default {
  name: 'changeRoom',
  props: {
    isPopup: {
      type: Boolean,
      default: () => false
    },
    submitUrl: {
      type: String,
      default: () => '/BizMemberDormitoryApply/Apply'
    }
  },
  components: {
    changeAddr
  },
  data() {
    return {
      showBankList: false,
      userInfo: {},
      addrVisible: false,
      newMembers: [],
      newSingleMember: '',
      memberList: [],
      isOnly: false,
      IsProxy: false,
      currentUserInfo: {},
      newOperations: [],
      newSingleOperation: '',
      isWarning: false,
      newRefundInfo: {
        Price: 0,
        Deposit: 0,
        BankNumber: '',
        RentReason: '',
        Bank: ''
      },
      bankList: [],
      errorMsg: {
        Price: '',
        Deposit: '',
        BankNumber: '',
        RentReason: '',
      },
      newDormitoryId: '',
      newAddress: '',
      userValidOrderInfo: {
        BizOrderPackageInfo: {},
        BizParentOrder: {},
      },
      targetAddrValidOrderInfo: {
        BizOrderPackageInfo: {},
        BizParentOrder: {}
      },
      allMemberList: [],
      hasValidOrder: false,
      showOldOrder: false,
      showNewOrder: false,
      addr: {
        RegionName: '',
        FullAddress: ''
      },
      userValidOrderLoading: false,
      targetAddrValidOrderLoading: false
    }
  },
  computed: {
    isDisabledReturn() {
      if(this.isOnly) {
        return this.newOperations.indexOf('IsCreate') > -1 || this.newOperations.indexOf('IsCancel') > -1
      }
      else {
        return !this.currentUserInfo.IsProxy || this.newOperations.indexOf('IsCancel') > -1 || this.newMembers.length > 0
      }
    },
    isDisabledCancel() {
      if(this.isOnly) {
        return this.newOperations.indexOf('IsReturn') > -1
      }
      else {
        return !this.currentUserInfo.IsProxy || this.newOperations.indexOf('IsReturn') > -1 || this.newMembers.length > 0 || (this.newOperations.indexOf('IsCreate') > -1 && this.newOperations.indexOf('IsCancel') > -1)
      }
    },
    isDisabledIsCreate() {
      return this.isWarning || (!this.isOnly && !!this.newMembers.length)
    }
  },
  methods: {
    checkMoney(type){
      this.newRefundInfo[type] = !this.newRefundInfo[type] ? 0 : this.newRefundInfo[type]
    },
    /**
     * 操作处理发生变化时
     */
    changeSingleOperation(){
      this.$set(this, 'newSingleMember', '')
      if (this.newSingleOperation === 'IsReturn') {
        this.getBank()
      }
    },
    onConfirm(value){
      this.$set(this.newRefundInfo, 'Bank', value.Value)
      this.showBankList = false;
    },
    async getBank() {
      try{
        const { Data } = await this.$post('/BizMemberDictionary/AllList',{ParetnName: '退租开户银行'})
        this.bankList = Data
        this.bankList.forEach((data) => {
          data.text = data.Name;
        });
        this.$set(this.newRefundInfo,'Bank', Data.length ? Data[0].Name : '')
      } catch(e){

      }
    },
    changeNewMember() {
      this.newOperations = []
    },
    async getNewAddr(data) {
      this.targetAddrValidOrderLoading = true
      this.showNewOrder = false
      try {
        const params =  {
          DormitoryId: data[data.length - 1].Id
        }
        const { Data } = await this.$post('/BizMemberOrder/NewDormitoryEffectiveOrder', params)
        this.targetAddrValidOrderInfo = Data
        if (!Data){
          // this.$toast.fail('该寝室下已有有效订单!')
          // this.newOperations = []
          this.newSingleOperation = ''
          if (!this.hasValidOrder) {
            this.newSingleOperation = '直接换寝'
            // this.newOperations.push('直接换寝')
          }
        }
        this.isWarning = !!Data
        this.newDormitoryId = data[data.length - 1].Id
        const newUserAddr = data.slice(1)
        // this.newAddress = data[0].Name + '-' + newUserAddr.map(res => res.Name).join('')
        this.newAddress = data.map(res => res.Name).join('-')
        this.addr.RegionName = data[0].Name
        this.addr.FullAddress = newUserAddr.map(res => res.Name).join('-')
        this.showNewOrder = true
        this.targetAddrValidOrderLoading = false
      }catch (e) {
        this.targetAddrValidOrderLoading = false
      }

      this.addrVisible = false
    },
    submit(){
      const IsCreate = this.newSingleOperation === 'IsCreate'
      const IsCancel = this.newSingleOperation === 'IsCancel'
      const IsReturn = this.newSingleOperation === 'IsReturn'


      if (!this.newDormitoryId){
        this.$toast.fail('请先选择新地址！')
        return false;
      }


      if(this.newDormitoryId === this.userInfo.DormitoryId){
        this.$toast.fail('不能选择原地址！')
        return false;
      }


      let params = {
        DormitoryId: this.newDormitoryId,
      };

      // 有有效订单
      if (this.hasValidOrder) {
        params.Id = this.currentUserInfo.Id

        // 目标寝室有合同同时原寝室只有自己时
        if (this.isOnly && this.isWarning && !this.newSingleOperation) {
          this.$toast.fail('请先选择操作处理！')
          return false;
        }

        if (!this.isOnly && this.newSingleOperation === 'IsCancel' && !this.newSingleMember){
          this.$toast.fail('请先选择新代表！')
          return false;
        }


        if (this.newSingleMember) {
          params.ContractMemberId = this.newSingleMember;
        }
        params.IsCreate = IsCreate;
        params.IsCancel = IsCancel;
        params.IsReturn = IsReturn
        if (params.IsReturn) {
          if (this.newRefundInfo.Deposit === "") {
            this.errorMsg.Deposit = '请输入退款押金'
            return false;
          } else {
            this.errorMsg.Deposit = ''
          }
          if (this.newRefundInfo.Price === "") {
            this.errorMsg.Price = '请输入退款租金'
            return false;
          } else {
            this.errorMsg.Price = ''
          }
          if (!this.newRefundInfo.BankNumber) {
            this.errorMsg.BankNumber = '请输入银行卡号'
            return false;
          } else {
            const regex = /^\d{19}$/
            if(!regex.test(this.newRefundInfo.BankNumber)) {
              this.errorMsg.BankNumber = "请输入正确的银行卡号";
              return false;
            } else {
              this.errorMsg.BankNumber = ''
            }
          }
          if (!this.newRefundInfo.RentReason) {
            this.errorMsg.RentReason = '请输入退租原因'
            return false;
          } else {
            this.errorMsg.RentReason = ''
          }
          params.bizReturnSend = {
            OrderId: this.userValidOrderInfo.Id,
            RentReason: this.newRefundInfo.RentReason,
            BankNumber: this.newRefundInfo.BankNumber,
            Deposit: this.newRefundInfo.Deposit,
            Price: this.newRefundInfo.Price,
            Bank: this.newRefundInfo.Bank
          }
        }
        params.OrderId = this.userValidOrderInfo.Id
      }else {
        params.MemberId = this.userInfo.Id
      }
      this.$post(this.submitUrl, params).then(res => {
        if(res.Status === 1) {
          this.$toast.success(res.Message)
          // if (IsCreate){
          //   this.$router.push({
          //     name: 'rent',
          //     query: {
          //       OrderId: res.Data.Id,
          //       DormitoryId: this.newDormitoryId,
          //       PackageId: res.Data.PackageId,
          //       MemberId: this.newSingleMember,
          //       IsCancel: IsCancel,
          //       isPay: true,
          //       type: 'change'
          //     }
          //   })
          // }
          if (this.isPopup) {
            this.$emit('cancel', 'refresh')
          }else {
            this.$router.replace({ path: '/equipment/orderMain', query: {type: '换寝', title: '换寝申请', backUrl: 'user'}})
          }
          // if (this.newSingleMember || IsCreate) {
          //   this.$router.replace({ path: '/equipment/orderMain', query: {type: '换寝', title: '换寝申请', backUrl: 'user'} })
          //   return false
          // }
        }else {
          this.$toast.fail(res.Message)
        }
      })
    },
    replaceNumber(val) {
      this.$set(
          this.newRefundInfo,
          val,
          this.newRefundInfo[val].match(/^\d*(\.?\d)/g)[0]
      );
    },
    replacePrice(val) {
      this.$set(
          this.newRefundInfo, val,
          this.newRefundInfo[val].match(/^\d*(\.?\d{0,2})/g)[0]
      );
      if (val === 'Price') {
        if (this.newRefundInfo[val] > this.userValidOrderInfo.BizParentOrder.Price) {
          this.newRefundInfo[val] = this.userValidOrderInfo.BizParentOrder.Price;
        }
      }
      if (val === 'Deposit') {
        if (this.newRefundInfo[val] > this.userValidOrderInfo.BizParentOrder.Deposit) {
          this.newRefundInfo[val] = this.userValidOrderInfo.BizParentOrder.Deposit;
        }
      }
    },
    linkage() {
      if(this.isOnly && this.newOperations.indexOf('IsCreate') > -1 && this.newOperations.indexOf('IsCancel') < 0) {
        this.newOperations.push('IsCancel')
      }
      if(this.isOnly) {
        if(this.newOperations.indexOf('IsCreate') > -1 && this.newOperations.indexOf('IsReturn') > -1) {
          const index = this.newOperations.findIndex(cur=>cur==='IsReturn');
          this.newOperations.splice(index,1)
        }
        if(this.newOperations.indexOf('IsReturn') > -1 && this.newOperations.indexOf('IsCancel') > -1) {
          const index = this.newOperations.findIndex(cur=>cur==='IsCancel');
          this.newOperations.splice(index,1)
        }
      } else {
        if(!this.newMembers.length) {
          if(this.newOperations.indexOf('IsCreate') > -1 && this.newOperations.indexOf('IsCancel') < 0 && this.currentUserInfo.IsProxy) {
            this.newOperations.push('IsCancel')
          }
          if(!this.isWarning && this.newOperations.indexOf('IsCreate') > -1 && this.newOperations.indexOf('IsReturn') > -1) {
            const index = this.newOperations.findIndex(cur=>cur==='IsReturn');
            this.newOperations.splice(index,1)
          }
        }
      }

    },
    cancel() {
      if (this.isPopup) {
        this.$emit('cancel')
      }else {
        this.$router.replace({name: this.$route.query.backUrl || 'user'})
      }
    },
    async getMemberData() {
      // 是否代表
      const index = this.allMemberList.findIndex(cur => cur.Id === this.userInfo.Id)
      this.IsProxy = index > -1
      this.currentUserInfo = index> -1 ? this.allMemberList[index] : {}
      this.isOnly = this.allMemberList.length < 2
    },
    // 用户信息
    getUserInfo() {
      this.userInfo = JSON.parse(getWeixInfo())
    },
    // 用户有效订单
    async getUserValidOrders() {
      this.userValidOrderLoading = true
      this.hasValidOrder = false
      try {
        const { Data } = await this.$post('/BizMemberOrder/MemberEffectiveOrder')
        this.userValidOrderInfo = Data
        if (Data){
          this.allMemberList = await this.getAlLMemberData()
          await this.getMemberData()
          this.hasValidOrder = true
          this.newOperations = []
        }else {
          this.hasValidOrder = false
          this.newOperations.push('直接换寝')
        }
        this.userValidOrderLoading = false
        this.showOldOrder = true
      }catch (e) {
        this.userValidOrderLoading = false
      }
    },
    async getAlLMemberData() {
      // const params = {
      //   ParentOrderId: this.ParentOrderDetails.Id,
      //   PageIndex:1,
      //   PageSize: 1000
      // }
      try {
        const {Data} = await this.$post('/BizMemberMember/MemberList', {})
        return Data
      } catch (e) {
        return []
      }
    },
  },
  mounted() {
    this.getUserInfo()
    this.getUserValidOrders()
    // this.getMemberData()
  }
}

</script>

<style scoped lang="less">
.change-room {
  height: 100vh;
  background-color: #ffffff;
  .top-btn {
    padding: 10px;
    height: 52px;
    display: flex;
    justify-content: center;
    > div {
      width: 50px;
      height: 32px;
      border-radius: 6px;
      text-align: center;
      line-height: 32px;
      color: #ffffff;
      display: inline-block;
      vertical-align: top;

      &.cancel {
        color: #333333;
        margin-right: 30px;
        border: 1px solid #ebedf0;
      }

      &.submit {
        background-color: #4AC064;
        float: right;
      }
    }
  }

  .bottom-part{
    padding: 10px 20px;
    //height: calc(100% - 32px - 20px);
    width: 100%;
    //overflow-y: auto;
  }

  .title {
    padding: 10px 0 20px 0;
    font-size: 18px;
  }

  .basic {
    > div {
      line-height: 20px;
      color: #9F9F9F;
      &:nth-child(1) {
        color: #333333;
      }
    }
  }

  .new-addr {
    >div{
      display: flex;
      align-items: start;
    }
    i{
      margin-top: 2px;
      font-size: 18px;
      margin-right: 5px;
    }
    .n_addr{
      padding-right:25px;
      display: flex;
    }
    &.van-cell {
      .van-cell__value {
        span {
          padding-left: 8px;
          color: #9F9F9F;
        }
      }

    }
  }

  .group-item {
    >div:nth-child(1){
      font-weight: bold;
      font-size: 16px;
    }
    .van-checkbox-group,.van-radio-group {
      margin-top: 15px;
      .van-icon{
        border-radius: 5px;
      }
      .van-checkbox,.van-radio {
        width: 100%;
        display: flex;
        margin: 10px 0;
        ::v-deep.van-checkbox__label {
          display: inline-block;
          width: 100%;
        }
        ::v-deep.van-radio__label {
          display: inline-block;
          width: 100%;
        }
      }
    }

    &.refund{
    }
  }


  .order-box{
    padding: 10px;
    border: 1px solid;
    border-radius: 8px;
    height: 115px;
    .van-col{
      color: #999999;
      line-height: 24px;
      font-size: 14px;
      &:nth-child(1) {
        color: #333333;
      }
    }


    &.valid-orders-old{
      margin-top: 10px;
      background-color: #F0FFF4;
      border-color: #4AC165;
    }

    &.valid-orders-new{
      margin-bottom: 10px;
      background-color: #FFFAF0;
      border-color: #E3B37B;
    }
  }


  .van-divider {
    margin: 10px 0;
  }

  .van-cell {
    padding: 8px 0;

    &::after {
      border-bottom: 0 !important;
    }
  }
}
</style>
